// Before a document is printed
window.addEventListener( 'beforeprint', ( event ) => {

  // Loop through all the details elements
  document.querySelectorAll( 'details' ).forEach( function( element ) {

    // If it's not open
    if ( ! element.getAttribute( 'open' ) ) {

      // Open it
      element.setAttribute( 'open', '' );

      // Mark it for closing after printing
      element.setAttribute( 'data-close-after-printing', 'true' );
    }

  } );

});

// After a document is printed
window.addEventListener( 'afterprint', ( event ) => {

  // Loop through all the details elements
  document.querySelectorAll( 'details' ).forEach( function( element ) {

    // If it was closed before printing
    if ( element.getAttribute( 'data-close-after-printing' ) ) {

      // Close it
      element.removeAttribute( 'open' );

      // Remove the close flag
      element.removeAttribute( 'data-close-after-printing' );
    }

  } );

});
